function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .money_svg__money_svg__cls-1{fill:#717375}.money_svg__money_svg__cls-2{fill:none;stroke:#717375;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}\n    "));

var _ref2 = /*#__PURE__*/React.createElement("title", null, "\n    money\n  ");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "money_svg__money_svg__cls-1",
  d: "M16.28,14a2.73,2.73,0,0,1,.8,2.13,2.73,2.73,0,0,1-.8,2.13,3.53,3.53,0,0,1-2,.92.33.33,0,0,0-.26.33v.63a.62.62,0,0,1-.63.62.61.61,0,0,1-.62-.62v-.63a.36.36,0,0,0-.26-.33,3.81,3.81,0,0,1-2-.95,3.1,3.1,0,0,1-.77-1.4.91.91,0,0,1,.88-1.14h0a.87.87,0,0,1,.88.7,1.35,1.35,0,0,0,.48.84,1.94,1.94,0,0,0,1.36.48,2,2,0,0,0,1.32-.4,1.38,1.38,0,0,0,.48-1.14,1.54,1.54,0,0,0-.44-1.11,3.74,3.74,0,0,0-1.44-.77A6.62,6.62,0,0,1,10.87,13a2.81,2.81,0,0,1-.81-2.13,3,3,0,0,1,.77-2.1,3.48,3.48,0,0,1,1.88-1A.33.33,0,0,0,13,7.47v-.8A.62.62,0,0,1,13.59,6h0a.62.62,0,0,1,.62.63v.84a.29.29,0,0,0,.26.3,3.1,3.1,0,0,1,1.84,1.06A3.4,3.4,0,0,1,17,10.23a.94.94,0,0,1-.91,1.1H16a.94.94,0,0,1-.92-.73,1.73,1.73,0,0,0-.37-.81,1.45,1.45,0,0,0-1.17-.59,1.62,1.62,0,0,0-1.18.41,1.63,1.63,0,0,0-.4,1.14,1.43,1.43,0,0,0,.4,1.06,4,4,0,0,0,1.51.81A6.79,6.79,0,0,1,16.28,14Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "money_svg__money_svg__cls-2",
  cx: 13.41,
  cy: 13.41,
  r: 12.66
})));

function SvgMoney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26.82,
    height: 26.82,
    viewBox: "0 0 26.82 26.82"
  }, props), _ref, _ref2, _ref3);
}

export default SvgMoney;